module.exports = __webpack_public_path__ + "13362db75b6682c7b3511ea7948b21b6.png";